module.exports = __webpack_public_path__ + "8fee7d724f134c3e85570795bc257945.jpg";